/**
 * MED-1040 — shared card style tokens for the post-session pages (coach,
 * participant, peer-leader), so every card matches the stepper "PROGRESS STRIP"
 * treatment: rounded 12px corners + a soft shadow, no hard border. Single
 * source of truth — apply `radius={POST_SESSION_CARD_RADIUS}` and
 * `style={{ boxShadow: POST_SESSION_CARD_SHADOW }}` (and drop `withBorder`) to
 * each card root.
 */
export const POST_SESSION_CARD_RADIUS = 12;
export const POST_SESSION_CARD_SHADOW = '0 1px 1.5px rgba(0, 0, 0, 0.06)';

/**
 * MED-1053 — primary post-session action-button color (navy), matching the
 * Figma's primary actions (recap "Edit & Send", the in-session nav). Shared by
 * Save attendance / Save notes / Edit & Send so they're consistent.
 */
export const POST_SESSION_PRIMARY_BG = '#1B2B3A';
